import React from 'react';
import IconBase from './IconBase';
const CheckMarkIcon = props => React.createElement(IconBase, props, React.createElement("polyline", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "7.263,32.13 23.188,48.055 56.658,14.586 "
}));
CheckMarkIcon.displayName = 'CheckMarkIcon';
export default CheckMarkIcon;
//# sourceMappingURL=CheckmarkIcon.js.map